import React from 'react'

import { images } from 'config/images'
import './InputButton.scss'

const InputButton = props => {
  const {
    isDefaultInputButton,
    isHoverInputButton,
    isLoading,
    isEditMode,
    ...buttonProps
  } = props
  return (
    <button
      className={[
        isDefaultInputButton ? 'btn__InputButtonDefault' : 'btn__InputButton',
        isHoverInputButton ? 'btn_is_hover' : '',
      ].join(' ')}
      {...buttonProps}
      disabled={isLoading || !isEditMode}
    >
      {isLoading ? (
        <img
          className="input_btn_loader"
          src={images.ico_loader}
          width="35"
          height="35"
          alt="loader"
        />
      ) : (
        props.children
      )}
    </button>
  )
}

InputButton.defaultProps = {
  isDefaultInputButton: false,
  isHoverInputButton: false,
  isLoading: false,
  isEditMode: true,
}
export default InputButton
